<div class="m-3 d-flex flex-column gap-3">
	<div class="row g-3">
		<div class="col-md-4">
			<mat-form-field class="w-100" appearance="outline">
				<mat-label>Plan trasy</mat-label>
				<input
					matInput
					type="number"
					min="0"
					[ngModel]="plannedRouteKilometers()"
					[disabled]="editable()"
					(ngModelChange)="onPlannedRouteKilometersChange($event)"
					(wheel)="onNumberInputWheel($event)"
				/>
				<span matSuffix class="me-2">KM</span>
				<mat-hint>Planowany dystans całej trasy produktu</mat-hint>
			</mat-form-field>
		</div>
	</div>

	@for (row of transitCountryFees(); track $index; let index = $index) {
		<div class="row g-3 align-items-center">
			<div class="col-md-4">
				<mat-form-field class="w-100" appearance="outline">
					<mat-label>Kraj</mat-label>
					<mat-select
						[ngModel]="row.location"
						[compareWith]="compareById"
						[disabled]="editable()"
						(ngModelChange)="row.location = $event; syncToService()"
					>
						@for (country of countries(); track country.id) {
							<mat-option [value]="country">{{ country.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="col-md-3">
				<mat-form-field class="w-100" appearance="outline">
					<mat-label>Opłata drogowa</mat-label>
					<input
						matInput
						type="number"
						min="0"
						step="0.01"
						[ngModel]="row.fee !== null ? (row.fee | price) : null"
						[disabled]="editable()"
						(ngModelChange)="onFeeChange(row, $event)"
						(wheel)="onNumberInputWheel($event)"
					/>
					<span matSuffix class="me-2">PLN</span>
				</mat-form-field>
			</div>

			<div class="col-auto">
				<button
					mat-icon-button
					type="button"
					color="warn"
					class="d-flex align-items-center justify-content-center"
					[disabled]="editable()"
					(click)="removeRow(index)"
					aria-label="Usuń wiersz"
				>
					<i class="fa-solid fa-trash-can"></i>
				</button>
			</div>
		</div>
	}

	<button
		mat-raised-button
		color="primary"
		type="button"
		class="align-self-start"
		[disabled]="editable()"
		(click)="addRow()"
	>
		<i class="fa-solid fa-plus me-1"></i>
		Dodaj
	</button>
</div>
